import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { useDispatch, useSelector } from 'react-redux';
import { setOpenProgress } from '../../redux/openProgress';
import Table from '../../components/Table';
import Popover from '../../components/popover/Popover';
import deLocale from 'date-fns/locale/pt-BR';
import { DateTimePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TextField } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import DateFnsUtils from '@date-io/date-fns';

function EquipmentSpents() {
  const [equipmentSpents, setEquipmentSpents] = useState([]);
  const [locale, setLocale] = React.useState('pt');

  const openProgress = useSelector((state) => state.openProgress.openProgress);
  const dispatch = useDispatch();
  const columns = [
    {
      title: 'Equipamento',
      field: 'equipment.name',
      type: 'string',
      hideFilterIcon: true,
    },
    {
      title: 'Data de Início',
      field: 'startTime',
      type: 'date',
      hideFilterIcon: true,
      editable: 'never',
      dateSetting: { locale: 'pt-BR' },
    },
    {
      title: 'Data/Hora de início',
      field: 'startTime',
      type: 'datetime',
      hideFilterIcon: true,
      editComponent: (props) => (
        <LocalizationProvider adapterLocale={deLocale} dateAdapter={DateFnsUtils}>
          <DateTimePicker
            format="dd/MM/yyyy HH:mm:ss"
            value={props.value}
            onChange={props.onChange}
            InputProps={{
              style: {
                fontSize: 13,
              },
            }}
            fullWidth
                        // inputFormat="DD/MM/YYYY HH:mm:ss"
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
      ),
    },

    {
      title: 'Data/Hora do fim',
      field: 'endTime',
      type: 'datetime',
      hideFilterIcon: true,
      editComponent: (props) => (
        <LocalizationProvider adapterLocale={deLocale} dateAdapter={DateFnsUtils}>
          <DateTimePicker
            format="dd/MM/yyyy HH:mm:ss"
            value={props.value}
            onChange={props.onChange}
            InputProps={{
              style: {
                fontSize: 13,
              },
            }}
            fullWidth
                        // inputFormat="DD/MM/YYYY HH:mm:ss"
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
      ),
    },

    {
      title: 'Consumo estimado (em kWs)',
      field: 'estimatedConsumption',
      type: 'real',
      hideFilterIcon: true,
    },
    {
      title: 'Viveiros',
      field: 'ponds',
      render: (rowData) => {
        let ponds_ = '';
        let pondsvalue = '';

        rowData.ponds.forEach(
          (ponds) => {
            ponds_ += `${ponds.description}, `;
            pondsvalue += ponds.description;
          },
        );
        return (
          <Popover
            data={ponds_.slice(0, -2)}
            altdata={pondsvalue.slice(0, -2)}
          />
        );
      },
      hideFilterIcon: true,
    },
  ];

  useEffect(() => {
    async function loadData() {
      try {
        const response = await api.get('/equipment-spents');

        if (response.data.length === 0) {
          dispatch(setOpenProgress(true));
        }
        if (response.data) {
          setEquipmentSpents(response.data);
          dispatch(setOpenProgress(true));
        }
      } catch (err) {
      }
    } loadData();
  }, [dispatch]);

  function setData(newData) {
    const tempData = [];
    equipmentSpents.map((equipmentSpents) => (
      equipmentSpents.id === newData.id ? tempData.push(newData) : tempData.push(equipmentSpents)
    ));
    setEquipmentSpents(tempData);
  }

  return (
    <Table
      title="Consumo energético de equipamento"
      route="/equipment-spents/"
      routeAdd="/equipment-spent/"
      columns={columns}
      data={equipmentSpents}
      setData={setData}
      dataLoaded={openProgress}
    />
  );
}

export default EquipmentSpents;
